/**
 * Promokod (chegirma) kontraktlari — admin CRUD (POS) + buyer validate/apply.
 *
 * Pul: Decimal → DTO'larda STRING. Discount hisobi (computeDiscount) — server'da,
 * percent maxDiscount bilan cheklanadi, discount subtotaldan oshmaydi (total ≥ 0).
 */
import { z } from 'zod';
// ─── Admin (POS) — yaratish/tahrirlash ────────────────────────────
export const createPromoCodeSchema = z
    .object({
    code: z
        .string()
        .trim()
        .min(2, 'Kod juda qisqa')
        .max(40)
        .regex(/^[A-Za-z0-9_-]+$/, 'Faqat harf, raqam, - va _')
        .transform((v) => v.toUpperCase()),
    description: z.string().trim().max(200).nullable().optional(),
    discountType: z.enum(['PERCENT', 'FIXED']),
    value: z.number().positive('Qiymat 0 dan katta'),
    minOrder: z.number().nonnegative().nullable().optional(),
    maxDiscount: z.number().positive().nullable().optional(),
    usageLimit: z.number().int().positive().nullable().optional(),
    startsAt: z.string().datetime().nullable().optional(),
    expiresAt: z.string().datetime().nullable().optional(),
    isActive: z.boolean().optional(),
})
    .refine((d) => d.discountType !== 'PERCENT' || d.value <= 100, {
    message: 'Foiz 100 dan oshmasin',
    path: ['value'],
});
export const updatePromoCodeSchema = z.object({
    description: z.string().trim().max(200).nullable().optional(),
    value: z.number().positive().optional(),
    minOrder: z.number().nonnegative().nullable().optional(),
    maxDiscount: z.number().positive().nullable().optional(),
    usageLimit: z.number().int().positive().nullable().optional(),
    startsAt: z.string().datetime().nullable().optional(),
    expiresAt: z.string().datetime().nullable().optional(),
    isActive: z.boolean().optional(),
});
// ─── Buyer — kod validatsiya (checkout'dan oldin preview) ──────────
export const validatePromoSchema = z.object({
    code: z.string().trim().min(1).max(40),
    subtotal: z.number().nonnegative(),
});
//# sourceMappingURL=marketplace-promo.schema.js.map